type iPageStats = {
  page: number;
  limit?: number;
  total: number;
};

const getViewedRowsFromPageStats = ({
  page,
  total,
  limit = 9,
}: iPageStats): number => {
  if (total < 1 || page < 1) {
    return 0;
  }
  const maxElementsBeforeAndOnCurrentPage = limit * page;
  const countElementsWithoutMaxElementsBeforeAndOnCurrentPage =
    total - maxElementsBeforeAndOnCurrentPage;
  const countViewedByOffsetXPage =
    total - countElementsWithoutMaxElementsBeforeAndOnCurrentPage;
  const reallyViewedRows =
    countViewedByOffsetXPage > total ? total : countViewedByOffsetXPage;
  return reallyViewedRows;
};

export default getViewedRowsFromPageStats;
